<template>
    <v-container class="py-0">
        <v-row>
            <v-col cols="12" lg="7" xl="9"
            class="
            py-1
            px-0"
            >
                <v-card outlined height="100%"
                class="d-flex justify-center align-center elevation-10 secondary">
                    <!-- <iframe src="https://giphy.com/embed/dZ7KN0t59bEas"
                        width="480" height="336" frameBorder="0"
                        class="giphy-embed" allowFullScreen>
                    </iframe> -->
                    <!-- <youtube video-id="X5SWpshc8p0"
                    player-width="400"
                    player-height="300"
                    ></youtube> -->
                    <div class="video-container">
                        <!-- <div class="video-container"> -->
                            <!-- <iframe src="https://www.youtube.com/embed/klZNNUz4wPQ"
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media;
                            gyroscope; picture-in-picture"
                            https://youtu.be/ekVRAAxW3VI
                            old src: https://www.youtube.com/embed/X5SWpshc8p0
                            allowfullscreen></iframe> -->

                            <!-- <iframe :width="width" :height="height"
                            title="MicroTone Intro Video"
                            src="https://www.youtube.com/embed/ekVRAAxW3VI"
                            frameborder="0" allow="accelerometer; autoplay; encrypted-media;
                            gyroscope; picture-in-picture" allowfullscreen></iframe> -->

                            <!-- Use the element. You may use it before the lite-yt-embed JS
                            is executed. -->
                            <!-- @/assets/img/heroSupport/supportPoster.jpg -->

                            <lite-youtube videoid="BsGlJUc2hfg"
                            playlabel="Play: Microtone Introduction"
        :style=
        "{'background-image': `url(${require('@/assets/img/heroSupport/supportPoster720.jpg')})`}"

                            >
                                <button type="button" class="lty-playbtn">
                                     <span class="lyt-visually-hidden">Microtone Introduction</span>
                                </button>
                            </lite-youtube>
                        <!-- </div> -->
                    </div>
                </v-card>

            </v-col>

            <v-col cols="12" lg="5" xl="3"
            class="
            py-1
            px-0
            "
            >
                <v-card outlined height="100%" class="elevation-10 ml-lg-2">
                    <v-container fill-height no-gutters class="flex-column align-start">
                        <!-- <div class="text-overline pl-4 accent--text font-weight-bold">
                            Intonation, Perfected
                        </div> -->
                        <v-card-subtitle
                        class="py-0 text-overline accent2--text font-weight-black">
                            Intonation, Perfected
                        </v-card-subtitle>
                        <v-card-title v-html="cardTitle"
                        class="py-0 text-h5 text-sm-h4 title-fix secondary--text">
                            <!-- Pure harmony, <br/>at last -->
                            {{ cardTitle }}
                        </v-card-title>

                        <v-card-text class="pt-2 pb-0 body-1 info--text">
                            Have you ever tuned a chord by ear, made it sound beautiful, only to
                            discover that every other chord you play sounds very out of tune? It’s
                            not your fault! Every guitar, whether it’s an affordable beginner
                            instrument or a super-expensive concert guitar, has something in common:
                            they all have frets positioned in 12-tone Equal Temperament. This is a
                            pitch system adopted for its convenience in manufacturing, but
                            definitely not one that creates sweet sounding chords. There’s a
                            better way, and MicroTone Guitars has the answer.
                        </v-card-text>
                        <!-- <cta-btn /> -->
                        <v-spacer v-if="this.$vuetify.breakpoint.name=='xl'"></v-spacer>
                        <v-container v-if="this.$vuetify.breakpoint.name=='xl'"
                        class="d-flex ctaContainer justify-center align-end">
                            <cta-btn buttonWidth="250"/>
                        </v-container>
                        <v-spacer v-if="this.$vuetify.breakpoint.name=='xl'"></v-spacer>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
    </v-container>


</template>

<script>

export default {
  data() {
    return {
      width: 560,
      height: 315,
    };
  },
  computed: {
    cardTitle() {
      // Insert a line break for any breakpoint other than small or medium
      if (['sm', 'md'].includes(this.$vuetify.breakpoint.name)) {
        return 'Pure harmony, at last';
      }

      return 'Pure harmony,<br> at last';
    },
  },
};
</script>

<style>
/* See: https://flaviocopes.com/responsive-youtube-videos/ */
.video-container {
    overflow: hidden;
    position: relative;
    width:100%;
}

.video-container::after {
    padding-top: 56.25%;
    display: block;
    content: '';
}

.video-container lite-youtube {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
lite-youtube {
    background-color: #000;
    position: relative;
    display: block;
    contain: content;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
    /* max-width: 720px; */
}

/* gradient */
lite-youtube::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    /* background-image: url('https://i.ytimg.com/vi/ogfYd705cRs/hqdefault.jpg'); */
    background-position: top;
    background-repeat: repeat-x;
    height: 60px;
    padding-bottom: 50px;
    width: 100%;
    transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);
}

/* responsive iframe with a 16:9 aspect ratio
    thanks https://css-tricks.com/responsive-iframes/
*/
lite-youtube::after {
    content: "";
    display: block;
    padding-bottom: calc(100% / (16 / 9));
}
lite-youtube > iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: 0;
}

/* play button */
lite-youtube > .lty-playbtn {
    width: 68px;
    height: 48px;
    position: absolute;
    cursor: pointer;
    transform: translate3d(-50%, -50%, 0);
    top: 50%;
    left: 50%;
    z-index: 1;
    background-color: transparent;
    /* YT's actual play button svg */
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 68 48"><path fill="%23f00" fill-opacity="0.8" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"></path><path d="M 45,24 27,14 27,34" fill="%23fff"></path></svg>');
    filter: grayscale(100%);
    transition: filter .1s cubic-bezier(0, 0, 0.2, 1);
    border: none;
}

lite-youtube:hover > .lty-playbtn,
lite-youtube .lty-playbtn:focus {
    filter: none;
}

/* Post-click styles */
lite-youtube.lyt-activated {
    cursor: unset;
}
lite-youtube.lyt-activated::before,
lite-youtube.lyt-activated > .lty-playbtn {
    opacity: 0;
    pointer-events: none;
}

.lyt-visually-hidden {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

</style>
